import { SubtramiteEstado } from "./types";

export const getSubtramiteEstado = (subtramite: any): SubtramiteEstado => {
  if (subtramite === null || subtramite === undefined) {
    return "pendiente";
  }

  return subtramite.estado;
}

